import { ACTIONS } from '../Constants';

const version = (state = '', action) => {
    switch (action.type) {
        case ACTIONS.GET_VERSION:
            return action.payload && action.payload.version;
        default:
            return state;
    }
};

export default version;
